import { css } from '@leafygreen-ui/emotion';

export const overlineStyles = css`
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  line-height: 20px;
  letter-spacing: 0.4px;
`;
